<section class="centered-with-padding py-7">
  <a
    [queryParams]="{ categorie: data.category }"
    [routerLink]="data.backUrl"
    class="flex items-center gap-x-3.5 pb-5 font-bold">
    <app-svg [height]="14" [width]="7" class="rotate-180" src="assets/icons/caret-right.svg" />
    <span>{{ "GLOBAL.BACK" | translate }}</span>
  </a>
  <div class="drop-shadow-custom rounded-xl bg-gray-light p-5">
    <div class="grid grid-cols-1 items-center gap-x-7 gap-y-3 desk:grid-cols-[1fr_233px]">
      @let image = data.image;
      <h1 class="font-bold desk:col-span-2">{{ data.question }}</h1>
      <span [class.desk:col-span-2]="!image" [innerHTML]="data.answer" handleHtmlLinks></span>
      @if (image) {
        <div class="h-[190px] overflow-hidden rounded-2xl">
          <app-image [image]="image" [isPriority]="!isImageInPreviousBlocks" />
        </div>
      }
    </div>
  </div>
</section>
